module.exports = __webpack_public_path__ + "static/media/13․062.cf8b9c8c.webp";